// Local avatar data
export const AVATAR_INFO = [
  { filename: 'avatar-1.webp', name: 'Diego Fiorito', translationKey: 'fiorito' },
  { filename: 'avatar-2.webp', name: 'Diego Cebollita', translationKey: 'cebollita' },
  { filename: 'avatar-3.webp', name: 'Diego Argentinos Jrs.', translationKey: 'argentinosJrs' },
  { filename: 'avatar-4.webp', name: 'Diego Mundial 82', translationKey: 'worldCup82' },
  { filename: 'avatar-5.webp', name: 'Diego Barcelona', translationKey: 'barcelona' },
  { filename: 'avatar-6.webp', name: 'Diego Mundial 86', translationKey: 'worldCup86' },
  { filename: 'avatar-7.webp', name: 'Diego Napoli', translationKey: 'napoli' },
  { filename: 'avatar-8.webp', name: 'Diego Mundial 94', translationKey: 'worldCup94' },
  { filename: 'avatar-9.webp', name: 'Diego Boca Jrs.', translationKey: 'bocaJrs' },
  { filename: 'avatar-10.webp', name: 'Diego DT Selección', translationKey: 'nationalTeamCoach' }
]
